import { Components, Theme, ThemeOptions } from '@mui/material/styles';

const getTabsTheme = (theme: Theme): ThemeOptions => {
  const tabsTheme: Components<Theme>['MuiTabs'] = {
    styleOverrides: {
      root: {
        minHeight: theme.unit(12),
        borderBottom: `1px solid ${theme.palette.M3.sys.light['outline-variant']}`,
      },
      indicator: {
        height: theme.unit(0.75),
        borderRadius: `${theme.unit(0.75)} ${theme.unit(0.75)} 0 0`,
      },
    },
  };

  const tabTheme: Components<Theme>['MuiTab'] = {
    styleOverrides: {
      root: {
        ...theme.typography.M3.title.small,
        minWidth: theme.unit(22.5),
        minHeight: theme.unit(12),
        color: theme.palette.M3.sys.light['on-surface-variant'],
        '&.Mui-selected': {
          color: theme.palette.M3.sys.light.primary,
        },
      },
      iconWrapper: {
        margin: theme.unit(0, 0, 1, 0),
      },
    },
  };

  return {
    components: {
      MuiTabs: tabsTheme,
      MuiTab: tabTheme,
    },
  };
};

export default getTabsTheme;
